import { createContext } from 'react';

import type { JSchema } from './types';
import type { createAntdFieldRule } from './utils/antd-rule';
import type { createValibotSchema } from './utils/valibot';

export const ValidationFormContext = createContext<
  | {
      antdRule: ReturnType<typeof createAntdFieldRule>;
      valibotSchema: ReturnType<typeof createValibotSchema>;
      jSchema: JSchema;
    }
  | undefined
>(undefined);
